import { SCIENCE_INTRO, SCIENCE_NOTES } from '../data/scienceContent.js';
import { INGREDIENTS } from '../data/ingredients.js';

/** Hidden until the visitor completes their own vote (rendered only on the
 * result screen by the parent). Preserves any real scientific write-up the
 * class provides in scienceContent.js — see that file's placeholder notice. */
export default function ScientificResults() {
  const notes = INGREDIENTS.map((i) => ({ ...i, note: SCIENCE_NOTES[i.slug] })).filter(
    (i) => i.note,
  );

  return (
    <section
      aria-labelledby="science-heading"
      className="mt-10 w-full rounded-3xl border border-showdown-cream/10 bg-showdown-ink p-6 sm:p-8"
    >
      <h2 id="science-heading" className="text-2xl font-extrabold text-showdown-blue sm:text-3xl">
        🔬 {SCIENCE_INTRO.heading}
      </h2>
      <p className="mt-3 text-base leading-relaxed text-showdown-cream/85 sm:text-lg">{SCIENCE_INTRO.summary}</p>

      {notes.length > 0 && (
        <dl className="mt-6 flex flex-col gap-4">
          {notes.map((i) => (
            <div key={i.id}>
              <dt className="font-bold">{i.name}</dt>
              <dd className="text-showdown-cream/80">{i.note}</dd>
            </div>
          ))}
        </dl>
      )}

      <a href="/more-info" className="mt-4 inline-block font-bold text-showdown-pink underline">
        more info
      </a>
    </section>
  );
}
